export default __webpack_public_path__ + "static/media/2_0000.b8146609.webp";